import { postRequest } from '../api';
import { getActionData } from '../reducers';
import { cancelOrderRequest } from '../api/requestCreator';
import { setBopisOrderCancelled } from '../analytics/gatherService';
import {
  handleCancelErrorAnalytics,
  handleOnlineCancelAnalytics,
} from '../analytics/utils';
import { ERRORS, REDUCERS } from '../constants';
import { safelyAccessNestedProperties } from '../utils';

const { LINE_ITEM_ERROR_CODE } = ERRORS;

export const createCancelLineItems = (
  selectedIdList: [string],
  itemList: Object
) =>
  selectedIdList.map((id: string) => {
    const lineItem = {
      lineReference: itemList[id].lineId.toString(),
      quantityToCancel: itemList[id].currentQuantity.toString(),
      skuCode: itemList[id].storeSKU,
    };
    if (
      itemList[id].fulfillment.fulfillmentMethod.toLowerCase() !==
      'buyonlinepickupinstore'
    ) {
      lineItem.fulfillmentCode = itemList[id].fulfillment.fulfillmentMethod;
      lineItem.lineType = itemList[id].lineType || 'SO';
    }
    return lineItem;
  });

export const submitCancelItems = (payload: Object) => (
  dispatch: Function,
  getState: Function
) => {
  // dispatch loading indicator on request
  dispatch({
    type: 'CANCEL_ITEMS_REQUEST',
  });

  const { orderId, lineItems, itemIdList, storeId, fulfillment } = payload;
  const state = getState();
  const order = getActionData(state, REDUCERS.ORDER_DETAILS, orderId);
  const { grandTotal: totalPrice } = order;
  const lines = createCancelLineItems(itemIdList, lineItems);
  const { url, data } = cancelOrderRequest(orderId, lines, storeId);

  postRequest(url, data).then(
    (response: Object) => {
      dispatch({
        type: 'CANCEL_ITEMS_SUCCESS',
        response: response.data,
      });

      if (
        fulfillment &&
        fulfillment.toLowerCase() === 'buyonlinepickupinstore'
      ) {
        setBopisOrderCancelled(orderId);
      } else {
        handleOnlineCancelAnalytics({
          fulfillment,
          orderId,
          totalPrice,
          itemIdList,
          lineItems,
          storeId,
        });
      }
    },
    (error: Object) => {
      const errorData = safelyAccessNestedProperties(
        ['response', 'data', 'errorData'],
        error
      );
      const errors = errorData
        ? errorData.errors.error
        : [{ code: 'OS_COMORDERDETAILS_ERR_2000' }];

      const lineItemErrors = errors.filter(
        (errorItem: Object) => errorItem.code === LINE_ITEM_ERROR_CODE
      );

      const lineItemErrorCodes = lineItemErrors.map((errorItem: Object) =>
        errorItem.description.match(/\d+/)
      );

      dispatch({
        type: 'CANCEL_ITEMS_FAILURE',
        payload: lineItemErrorCodes,
        message: error.message || 'Something went wrong.',
      });

      handleCancelErrorAnalytics(fulfillment, errors, lineItemErrors);
    }
  );
};

export const initCancelPage = (itemIds: array) => ({
  type: 'ONLINE_CANCEL_INIT',
  payload: itemIds,
});

export const selectCancelItem = (itemId: string) => ({
  type: 'CANCEL_ITEMS_SELECT',
  payload: itemId,
});

export const openBopisModal = () => ({
  type: 'OPEN_BOPIS_CANCEL_MODAL',
});

export const closeBopisModal = () => ({
  type: 'CLOSE_BOPIS_CANCEL_MODAL',
});

export const resetCancelPage = () => ({ type: 'ONLINE_CANCEL_RESET' });

export const bopisCancelSuccess = (orderId: String) => ({
  type: 'BOPIS_CANCEL_SUCCESS',
  payload: { orderId },
  filter: REDUCERS.ORDER_DETAILS,
});
